import { useMutation, useQueryClient } from '@tanstack/react-query';

import { messagingApi } from './api/messaging.api';
import { messagingKeys } from './queries';

export function usePostMessage(threadId: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: string) => messagingApi.post(threadId, body),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: messagingKeys.messages(threadId) });
      void client.invalidateQueries({ queryKey: messagingKeys.threads });
    }
  });
}

export function useMarkThreadRead() {
  const client = useQueryClient();
  return useMutation({ mutationFn: (threadId: string) => messagingApi.markRead(threadId), onSuccess: () => client.invalidateQueries({ queryKey: messagingKeys.threads }) });
}

export function useCreateThread() {
  const client = useQueryClient();
  return useMutation({ mutationFn: messagingApi.create, onSuccess: () => client.invalidateQueries({ queryKey: messagingKeys.threads }) });
}
